import React, { useEffect, useState } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { Helmet } from "react-helmet-async";

const FormBiodata = () => {
  const location = useLocation();
  const phonenumber = location.state?.phonenumber || '';
const navigate = useNavigate();
  
  const [nama, setNama] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun

  const [formdata, setFormData] = useState({
    npsn:'',
    kode_akses:'',
    noi:''
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(``);
    // Pastikan formdata tidak null atau undefined
    if (!formdata || Object.keys(formdata).length === 0) {
        setError('Data tidak boleh kosong');
        return;
    }
    console.log(formdata)

    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/usersweb/register_kode_akses2`, {
            method: 'POST',
            headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
            body: JSON.stringify(formdata),
        });
 const result = await response.json();
        if (!response.ok) {
            throw new Error(result.message);
        }

       

        // Update token jika diberikan oleh server
        if (result.token) {
            localStorage.setItem('authToken', result.token);
        }
       const decoded = jwtDecode(result.token);
           if(decoded.akses=="Pendidik"){
             navigate("/Pendidik");
           }else if(decoded.akses=="Operator"){
             navigate("/admin");
           }else{
             navigate("/daftar/identifikasiakses");
           } 
            window.location.reload(); // Arahkan ke halaman admin setelah sukses
    } catch (error) {
        setError(`Terjadi kesalahan: ${error.message}`);
    }
};

  const handleChange = (e) => {
    setFormData({ ...formdata, [e.target.name]: e.target.value });
  };

   useEffect(() => {
      const getInformasiAkun = async () => {
        console.log(localStorage.getItem('authToken'))
  
        const authToken = localStorage.getItem('authToken');
  
        if (!authToken) {
          console.error("Token required");
          return; // Jika tidak ada token, hentikan eksekusi
        }
  
        try {
          // Decode payload dari token JWT
          const decoded = jwtDecode(authToken);
          setInformasiAkun(decoded); // Simpan informasi akun ke state
  
  
          if(decoded.akses==null){
            navigate('/daftar/identifikasiakses'); 
          }
        } catch (error) {
          
          return;
        }
      };
      getInformasiAkun();
    }, []);


  return (
    <div>
      <Helmet>
              <title>Identifikasi Pengguna</title>
            </Helmet>
       <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="card shadow p-4" style={{ width: "100%", maxWidth: "420px" }}>
           <div className="text-center mb-4">
            <img
              src="/assets/images/logogvfix.png"
              width={100}
              alt="Logo"
              className="img-fluid mb-2"
            />
            <h4 className="text-secondary mt-3"><b>Hi, Selamat Datang</b></h4>
            <p className="text-muted">Lengkapi Biodata</p>
          </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-floating mb-3">
                    <input 
                      type="text"
                      name='nama'
                      required
                      value={formdata.nama}
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                      placeholder="NAMA" 
                    />
                    <label htmlFor="floatingNama">Nama Asli</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input 
                      type="text"
                      name='kode_akses'
                      required
                      value={formdata.kode_akses}
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                     
                      placeholder="Kode Registrasi" 
                    />
                    <label htmlFor="floatingNama">Reg Kode</label>
                  </div>
                  {/* <div className="form-floating mb-3">
                    <input 
                      type="text"
                      value={formdata.noi}
                      name='noi'
                     
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                      placeholder="No Induk Pegawai" 
                    />
                    <label htmlFor="floatingNama">No Induk Pegawai (Jika tidak ada Koosngkan Saja)</label>
                  </div>
                   */}
                 
                  <div className="d-grid mt-4">
                    <button type="submit" className="btn btn-secondary">Lanjutkan</button>
                  </div>
                </form>

                {error && <div className="alert alert-danger mt-2">{error}</div>}
                {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}

                <hr />
              </div>
            </div>
          </div>
  );
};

export default FormBiodata;
